import { render, staticRenderFns } from "./GatewayDetail.vue?vue&type=template&id=daf050fa&scoped=true"
import script from "./GatewayDetail.vue?vue&type=script&lang=ts"
export * from "./GatewayDetail.vue?vue&type=script&lang=ts"
import style0 from "./GatewayDetail.vue?vue&type=style&index=0&id=daf050fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf050fa",
  null
  
)

export default component.exports